//export const azureSearchRootUrl = "https://quransearch.search.windows.net/indexes/quran-v2/docs";
export const azureSearchRootUrl = "https://quransearch.search.windows.net/indexes/multilingual/docs";
export const websiteUrl = "https://beta.quranwow.com/";
export const websiteUrlFancy = "QuranWow.com";
export const baseTextUrl = "https://text.quranwow.com/";
export const iconColor = "#e8e8e8";
export const blueUrlColor = "#1967d2";
export const topAppBarHeight = "54px";
